import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getEmbedSettings } from '../state/selectors';
import { EmbedPartner } from '../enums/embed-partner';
import { PostMessage } from '../interfaces/post-message.interface';
import { PostMessageAction } from '../enums/post-message-action';
import { PostMessageParams } from '../interfaces/post-message-params.interface';

@Injectable({
  providedIn: 'root'
})
export class PostMessageService {
  private embedPartner: EmbedPartner | null = null;
  private embedCloudId: string | null = null;
  private embedOrigin: string | null = null;

  constructor(private store: Store) {
    this.store.pipe(select(getEmbedSettings)).subscribe(embedSettings => {
      if (embedSettings.cloudId) {
        this.embedCloudId = embedSettings.cloudId;
      } 

      if (embedSettings.partner) {
        this.embedPartner = embedSettings.partner;
      } 

      if (embedSettings.baseUrl) {
        this.embedOrigin = embedSettings.baseUrl;
      }
    });
  }

  buildMessagePayload(action: PostMessageAction, params?: PostMessageParams): PostMessage {
    return {
      service: "Digital Practice",
      action: action,
      params: params
   }
  }

  postMessage(action: PostMessageAction, params?: PostMessageParams): void {
    const payload = this.buildMessagePayload(action, params);
    const origin = this.embedOrigin;
    console.log('SEND POST MESSAGE', payload, origin);
    if (window.parent && this.embedOrigin) {
      window.parent.postMessage(payload, this.embedOrigin);
    }
  }
}